<ng-template #contentTemplate> <ng-content></ng-content> </ng-template>
<ng-container #contentOutlet></ng-container>
